import type { QueryClient } from '@tanstack/react-query'
import { documentsQuery } from './documents'
import { bankTransactionsQuery, eventsQuery, financeSummaryQuery, invoicesQuery, salesOverviewQuery } from './finance'
import { enquiriesQuery } from './leads'
import { tapBoardQuery } from './kegTaps'
import { loyaltyStatsQuery } from './loyalty'
import { qualityReportQuery } from './quality'
import { recipeCatalogQuery } from './recipes'
import { usersQuery } from './staff'
import { openKegTasksQuery, taskListQuery } from './tasks'

type Prefetch = (queryClient: QueryClient) => Promise<unknown>

const PREFETCH_BY_PATH: Record<string, Prefetch> = {
	'/': (queryClient) => queryClient.prefetchQuery(taskListQuery('mine')),
	'/tasks': (queryClient) => queryClient.prefetchQuery(taskListQuery('mine')),
	'/operations/on-tap': (queryClient) =>
		Promise.all([queryClient.prefetchQuery(recipeCatalogQuery()), queryClient.prefetchQuery(tapBoardQuery())]),
	'/operations/quality': (queryClient) => queryClient.prefetchQuery(qualityReportQuery()),
	'/operations/recipes': (queryClient) => queryClient.prefetchQuery(recipeCatalogQuery()),
	'/operations/shopping': (queryClient) =>
		Promise.all([queryClient.prefetchQuery(recipeCatalogQuery()), queryClient.prefetchQuery(openKegTasksQuery())]),
	'/handbook': (queryClient) => queryClient.prefetchQuery(documentsQuery()),
	'/leads': (queryClient) => queryClient.prefetchQuery(enquiriesQuery()),
	'/vouchers': (queryClient) => queryClient.prefetchQuery(loyaltyStatsQuery()),
	'/finance': (queryClient) => queryClient.prefetchQuery(financeSummaryQuery()),
	'/finance/sales': (queryClient) => queryClient.prefetchQuery(salesOverviewQuery()),
	'/finance/events': (queryClient) => queryClient.prefetchQuery(eventsQuery()),
	'/finance/transactions/bank': (queryClient) => queryClient.prefetchQuery(bankTransactionsQuery()),
	'/finance/invoices': (queryClient) => queryClient.prefetchQuery(invoicesQuery()),
	'/staff/users': (queryClient) => queryClient.prefetchQuery(usersQuery()),
}

export function prefetchForPath(queryClient: QueryClient, path: string): void {
	void PREFETCH_BY_PATH[path]?.(queryClient)
}
